exports = module.exports = require("../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".clipper-range[data-v-5423d72c]{-webkit-box-sizing:border-box;box-sizing:border-box;padding:10px}.wrap[data-v-5423d72c]{position:relative;height:25px;width:100%}.stick[data-v-5423d72c]{position:absolute;width:100%;height:2px;background-color:gray;top:50%;left:0;-webkit-transform:translateY(-50%);transform:translateY(-50%)}.bar[data-v-5423d72c]{position:absolute;cursor:pointer;width:12px;height:100%;background-color:#fff;-webkit-box-shadow:1px 1px 4px rgba(0,0,0,.5);box-shadow:1px 1px 4px rgba(0,0,0,.5);top:0;left:0}", ""]);

// exports
